module.exports = __webpack_public_path__ + "img/dial-med-low.3e832919.svg";